// extracted by mini-css-extract-plugin
export default {"cls1":"Lightbox-ImageContainer-module--cls1--hi3ow","cls2":"Lightbox-ImageContainer-module--cls2--IP0JG Lightbox-ImageContainer-module--cls1--hi3ow"};